<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div v-if="open" class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">客戶通聯資料</h3>
        </div>
        <div class="modal-body">
          <table class="table insurance-green">
            <tr>
              <th class="text-green text-right" width="14%">類別</th>
              <th class="text-green" width="21%">項目</th>
              <th class="text-green" width="40%">內容</th>
              <th class="text-green" width="25%">更新時間</th>
            </tr>
            <tr>
              <th class="text-green text-right">手機號碼</th>
              <td>手機號碼</td>
              <td>{{addressData.mobile}}</td>
              <td>{{addressData.mobile_update | ymdsDateFormat }}</td>
            </tr>
            <tr>
              <th class="text-green text-right" rowspan="3">電話號碼</th>
              <td>住家電話號碼</td>
              <td>{{addressData.homeTel | corpTelFormat}}</td>
              <td>{{addressData.tel_h_update | ymdsDateFormat }}</td>
            </tr>
            <tr>
              <td>公司電話號碼</td>
              <td>{{addressData.corpTel | corpTelFormat}}</td>
              <td>{{addressData.tel_o_update | ymdsDateFormat }}</td>
            </tr>
            <tr>
              <td>聯絡電話號碼</td>
              <td>{{addressData.tel | corpTelFormat}}</td>
              <td>{{addressData.tel_p_update | ymdsDateFormat }}</td>
            </tr>
            <tr>
              <th class="text-green text-right" rowspan="3">地址</th>
              <td>收費地址</td>
              <td>{{addressData.feeAdd | addressFormat }}</td>
              <td>{{addressData.addr_p_update | ymdsDateFormat }}</td>
            </tr>
            <tr>
              <!-- <td>戶籍地址</td>
              <td>{{addressData.censusAdd | addressFormat}}</td>
              <td>{{addressData.addr_h_update | ymdsDateFormat }}</td> -->
            </tr>
            <tr>
              <td>聯絡地址</td>
              <td>{{addressData.contactAdd | addressFormat}}</td>
              <td>{{addressData.addr_c_update | ymdsDateFormat }}</td>
            </tr>
            <tr>
              <th class="text-green text-right" rowspan="4">email</th>
              <td>email</td>
              <td>{{addressData.email}}</td>
              <td>{{addressData.email_update_date | ymdsDateFormat }}</td>
            </tr>
          </table>
          <p v-if="addressData.isRemoteDocumentWarningShow">
            說明:
            <br />資料來源依據單一資料庫，僅供查詢聯繫保戶使用，如資料有誤，請填聯繫單或A4變更申請書修正
          </p>
          <p v-else class="text-red">
            <ul class="transition-all unhighlighted" id="example-element" style="list-style-type: '※';">
              <li style="padding: 5px;">如欲修改「收費地址」：可透過「行動保全」協助保戶辦理變更。若遇無法以「行動保全」變更之特殊狀況(例：收費地址來自失效件)，請填寫簡覆表至數位支援科進行人工修正。</li>
              <li style="padding: 5px;">如欲修改「聯絡地址」：請至「壽險核心系統>收費事務管理>聯絡地址建檔作業」建檔。</li>
              <li style="padding: 5px;">如欲修改「手機號碼」：可以紙本「電話/Email變更申請書」或透過「行動保全」協助客戶變更；如客戶已申辦網路服務，可登入國泰人壽APP變更；或由客戶進線客服專線或至服務據點臨櫃辦理。</li>
            </ul>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IndexIntegratedAddressModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    addressData: {
      type: Object,
      defualt: () => {
        return {};
      }
    }
  }
};
</script>
